export default __webpack_public_path__ + "static/media/background-image.ebcb9160.svg";